let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jBhPn")).then(() => parcelRequire('fyWni'));